class ChangePassowordUsersController {
  static controller($rootScope, $scope, ProfileService) {
    'ngInject';
    
    $scope.saveNewPassword = function(newPasswordForm){
      if(!newPasswordForm.$valid){
        console.error("invalid form");
        return;
      }

      ProfileService.changePassword(newPasswordForm.oldPassword.$modelValue, newPasswordForm.password.$modelValue).then(function(data) {
        $scope.success = true;
      }, function(reason) {
        console.error('changePassword error', reason);
        $scope.success = false;
      });
    }
  }
}

export default ChangePassowordUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/changePassword.users.controller.js